import { useFormik } from "formik"
import { TApiTasksFilters } from "../../api-client/tasks-api"

interface useTasksFiltersFormikParams {
  initialValues?: TApiTasksFilters
  onSubmit(values: TApiTasksFilters): void
}

export const DEFAULT_TASKS_FILTERS = {
  name: "",
  state: "active",
  sectionStatus: 'active',
  isBillable: undefined,
  users: [],
  groups: [],
  tagIds: [],
} as TApiTasksFilters

const useTasksFiltersFormik = (params: useTasksFiltersFormikParams) => {
  const {
    initialValues,
    onSubmit,
  } = params

  const formik = useFormik<TApiTasksFilters>({
    initialValues: {
      ...DEFAULT_TASKS_FILTERS,
      ...initialValues
    },
    onSubmit: (values) => {
      onSubmit(values)
    }
  })

  return formik
}

export default useTasksFiltersFormik